import Model from './Model'

export default class ReportPost extends Model {
  resource() {
    return 'reports/posts'
  }
}
